module.exports = __webpack_public_path__ + "img/18_BC19_heed_your_greens.14104eed.jpg";